import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import { Checkbox, CheckboxGroup } from '../../../components/ui/Checkbox';

const ExportModal = ({ isOpen, onClose, selectedCount }) => {
  const [exportFormat, setExportFormat] = useState('csv');
  const [includeFields, setIncludeFields] = useState({
    clientId: true,
    fullName: true,
    birthDate: true,
    contact: true,
    occupation: true,
    status: true,
    caseWorker: true,
    lastContact: true
  });

  if (!isOpen) return null;

  const formatOptions = [
    { value: 'csv', label: 'CSV (Comma-Separated Values)' },
    { value: 'xlsx', label: 'Excel (XLSX)' },
    { value: 'pdf', label: 'PDF Dokument' },
    { value: 'json', label: 'JSON Daten' }
  ];

  const handleExport = () => {
    // Export logic would go here
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-card rounded-lg shadow-xl max-w-2xl w-full">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div>
            <h2 className="text-xl font-semibold text-foreground">Daten exportieren</h2>
            <p className="text-sm text-muted-foreground mt-1">{selectedCount} Klienten ausgewählt</p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-muted rounded-lg transition-colors"
          >
            <Icon name="X" size={20} className="text-muted-foreground" />
          </button>
        </div>

        <div className="p-6 space-y-6">
          <div>
            <Select
              label="Exportformat"
              description="Wählen Sie das gewünschte Dateiformat"
              options={formatOptions}
              value={exportFormat}
              onChange={setExportFormat}
            />
          </div>

          <div>
            <h3 className="text-sm font-medium text-foreground mb-3">Zu exportierende Felder</h3>
            <CheckboxGroup>
              <div className="grid grid-cols-2 gap-3">
                <Checkbox
                  label="Klienten-ID"
                  checked={includeFields?.clientId}
                  onChange={(e) => setIncludeFields({ ...includeFields, clientId: e?.target?.checked })}
                />
                <Checkbox
                  label="Vollständiger Name"
                  checked={includeFields?.fullName}
                  onChange={(e) => setIncludeFields({ ...includeFields, fullName: e?.target?.checked })}
                />
                <Checkbox
                  label="Geburtsdatum"
                  checked={includeFields?.birthDate}
                  onChange={(e) => setIncludeFields({ ...includeFields, birthDate: e?.target?.checked })}
                />
                <Checkbox
                  label="Kontaktinformationen"
                  checked={includeFields?.contact}
                  onChange={(e) => setIncludeFields({ ...includeFields, contact: e?.target?.checked })}
                />
                <Checkbox
                  label="Beruf"
                  checked={includeFields?.occupation}
                  onChange={(e) => setIncludeFields({ ...includeFields, occupation: e?.target?.checked })}
                />
                <Checkbox
                  label="Status"
                  checked={includeFields?.status}
                  onChange={(e) => setIncludeFields({ ...includeFields, status: e?.target?.checked })}
                />
                <Checkbox
                  label="Sachbearbeiter"
                  checked={includeFields?.caseWorker}
                  onChange={(e) => setIncludeFields({ ...includeFields, caseWorker: e?.target?.checked })}
                />
                <Checkbox
                  label="Letzter Kontakt"
                  checked={includeFields?.lastContact}
                  onChange={(e) => setIncludeFields({ ...includeFields, lastContact: e?.target?.checked })}
                />
              </div>
            </CheckboxGroup>
          </div>

          <div className="p-4 bg-warning/10 border border-warning/20 rounded-lg flex items-start gap-3">
            <Icon name="AlertTriangle" size={20} className="text-warning flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-medium text-warning">Datenschutzhinweis</p>
              <p className="text-sm text-muted-foreground mt-1">
                Exportierte Daten enthalten personenbezogene Informationen. Bitte stellen Sie sicher, dass die Daten gemäß DSGVO-Richtlinien behandelt werden.
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 p-6 border-t border-border">
          <Button variant="outline" onClick={onClose}>
            Abbrechen
          </Button>
          <Button variant="default" iconName="Download" iconPosition="left" onClick={handleExport}>
            Exportieren
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ExportModal;